import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { HttpEventType, HttpHeaders } from '@angular/common/http';
import { HeimtierKundenExcelImportPreviewDialogComponent } from '../heimtier-kunden-excel-import-preview-dialog/heimtier-kunden-excel-import-preview-dialog.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-heimtier-kunde-dialog',
    templateUrl: './heimtier-kunden-excel-import-dialog.component.html',
    styleUrls: ['./heimtier-kunden-excel-import-dialog.component.scss'],
})
export class HeimtierKundenExcelImportDialogComponent implements OnInit {
    protected readonly columnOptions: string[] = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ];

    protected nameColumn: string;
    protected kundennummerColumn: string;
    protected plzColumn: string;
    protected ortColumn: string;
    protected strasseColumn: string;
    protected mobilColumn: string;
    protected phoneColumn: string;
    protected mailColumn: string;
    protected kommentarColumn: string;

    protected file: File;

    private isLoading = false;

    @ViewChild('fileSelector') fileSelector: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<HeimtierKundenExcelImportDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {}

    public isDisabled(): boolean {
        return !(
            this.file &&
            this.nameColumn &&
            this.plzColumn &&
            this.ortColumn &&
            this.strasseColumn &&
            !this.isLoading
        );
    }
    openFileSelector() {
        this.fileSelector?.nativeElement?.click();
    }

    handleFile(event: any) {
        this.file = event.target.files[0];
    }

    public check(): void {
        this.isLoading = true;

        const fd = new FormData();
        fd.append('dokument', this.file);
        if (this.nameColumn) {
            fd.append('nameColumn', this.nameColumn);
        }
        if (this.kundennummerColumn) {
            fd.append('kundennummerColumn', this.kundennummerColumn);
        }
        if (this.plzColumn) {
            fd.append('plzColumn', this.plzColumn);
        }
        if (this.ortColumn) {
            fd.append('ortColumn', this.ortColumn);
        }
        if (this.strasseColumn) {
            fd.append('strasseColumn', this.strasseColumn);
        }
        if (this.mobilColumn) {
            fd.append('mobilColumn', this.mobilColumn);
        }
        if (this.phoneColumn) {
            fd.append('phoneColumn', this.phoneColumn);
        }
        if (this.mailColumn) {
            fd.append('mailColumn', this.mailColumn);
        }
        if (this.kommentarColumn) {
            fd.append('kommentarColumn', this.kommentarColumn);
        }

        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.api.postFormData(this.apiBaseUrl + 'heimtier_kunde/preimport_excel.php', fd, options).subscribe({
            next: event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round((100 * event.loaded) / event.total);
                    console.log(percentDone);
                } else {
                    let client: Client = event;
                    let dialogRef = this.dialog.open(HeimtierKundenExcelImportPreviewDialogComponent, {
                        width: '90%',
                        data: client,
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        this.isLoading = false;
                        if (result) {
                            this.actuallyUpload(fd);
                        }
                    });
                }
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler beim Hochladen!', err);
            },
        });
    }

    public actuallyUpload(fd): void {
        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.api.postFormData(this.apiBaseUrl + 'heimtier_kunde/import_excel.php', fd, options).subscribe({
            next: event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round((100 * event.loaded) / event.total);
                    console.log(percentDone);
                }
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler beim Hochladen!', err);
            },
            complete: () => {
                this.isLoading = false;
                this.messageService.infoMessage('Datei(en) erfolgreich hochgeladen!');
                this.dialogRef.close(true);
            },
        });
    }
}
